import { ConfigStateService } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

/** Server-side feature (OjsFeatures.Badges.Active) that switches achievements on for users. */
const BADGES_FEATURE = 'Badges.Active';

/**
 * Whether achievements are live, read from the application configuration ABP loads at startup.
 * While off, nothing badge-related is shown or requested, so the catalog and the backfill can be
 * prepared before launch; switching it on takes effect on the next page load.
 */
@Injectable({ providedIn: 'root' })
export class BadgesFeatureService {
  constructor(private configState: ConfigStateService) {}

  get isEnabled(): boolean {
    return (this.configState.getFeature(BADGES_FEATURE) || '').toLowerCase() === 'true';
  }
}

/** Keeps the achievements page unreachable while the feature is off (back to the profile). */
@Injectable({ providedIn: 'root' })
export class BadgesEnabledGuard implements CanActivate {
  constructor(private badgesFeature: BadgesFeatureService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.badgesFeature.isEnabled
      ? true
      : this.router.parseUrl(state.url.replace(/\/achievements.*$/, '') || '/profile');
  }
}
